import $ from 'jquery';
import utils from './utils/index';
import mediaBreakpoints from './utils/mediaBreakpoints';
import pageViewInit from './core/pageViewInit';

const u = navigator.userAgent;
const ua = u.toLowerCase();
const $window = $(window);
const $document = $(document);
const $html = $('html');
const $body = $('body');
const $header = $('#header');
const $main = $('#main');
const $footer = $('#footer');

let app = (window.app = {});
app.el = {
  $window,
  $document,
  $html,
  $body,
  $header,
  $main,
  $footer,
};

/* 访问终端
------------------------------------------------ */
app.browser = {
  platform: {
    windows: u.indexOf('Windows') > -1,
    macos: u.indexOf('Mac OS X') > -1,
    linux: u.indexOf('Linux') > -1,
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    mobile: !!u.match(/AppleWebKit.*Mobile.*/),
  },
  isTouch: 'ontouchstart' in window || ua.indexOf('touch') !== -1 || ua.indexOf('mobile') !== -1,
};
/* app暴露全局方法
------------------------------------------------ */
// 加载内容：js，css，style
app.loadFile = utils.loadFile;

// 锁定页面滚动条
app.scrollLock = function (lock = true) {
  if (lock) {
    $html.addClass('scroll-lock');
  } else {
    $html.removeClass('scroll-lock');
  }
};

// html浏览器标示
app.addBrowserTag = {
  platform() {
    let platform = app.browser.platform;
    for (let key in platform) {
      platform[key] && $html.addClass('platform_' + key);
    }
  },
  isTouch() {
    if (app.browser.isTouch) $html.addClass('is-touch');
  },
  cssSupport() {
    const css = {
      position: 'sticky',
    };
    for (let key in css) {
      utils.cssSupport(key, css[key], true);
    }
  },
};

/* 初始化页面加载的方法
------------------------------------------------ */
app.pageInit = function () {
  app.addBrowserTag.platform();
  app.addBrowserTag.isTouch();
  app.addBrowserTag.cssSupport();
  $html.addClass('scrollbar-width--' + utils.getScrollbarWidth());
  mediaBreakpoints($document);
  app.pageViewInit('everyPage');
};

/* 初始化Page展示方法
------------------------------------------------ */
app.pageViewInit = function (pageName, ...args) {
  const fn = pageViewInit[pageName];
  if (typeof fn == 'function') fn(...args);
};

// /* 初始化CMS方法
// ------------------------------------------------ */
// app.pageCmsInit = function () {
//   for (let fn of Object.values(app.pageCmsInit)) {
//     typeof fn == 'function' && fn();
//   }
// };

/* 异步加载JS(一般用于加载第三方js，例：百度地图)
------------------------------------------------ */
app.loadJS = function (url) {
  let script = document.querySelector(`script[src='${url}']`);
  if (!script) {
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
  }
  return new Promise((resolve, reject) => {
    script.addEventListener('load', () => resolve(script));
    script.addEventListener('error', () => reject(error));
  });
};

export default app;
